import { createUrl } from "@/redux/api";
import {
  AchievementQueryParams,
  AchievementResponse,
  CommonTags,
  CommunityRoleQueryParams,
  CommunityRoleResponse,
  CountryResponse,
  CountryQueryParams,
  LanguageResponse,
  LanguageQueryParams,
  TagType,
} from "@/redux/common/types";
import { isPaginatedResponse } from "@/redux/typeGuards";
import { BuilderType, PaginatedResponse } from "@/redux/types";

const commonService = (builder: BuilderType<CommonTags>) => ({
  getLanguages: builder.query<
    PaginatedResponse<LanguageResponse> | LanguageResponse[],
    LanguageQueryParams
  >({
    query: (queryParams) => ({
      url: createUrl("/languages/", queryParams),
      method: "GET",
    }),
    providesTags: (result): TagType[] =>
      result
        ? [
            ...(
              (isPaginatedResponse(result)
                ? result.results
                : result) as LanguageResponse[]
            ).map(
              (i): TagType => ({
                type: "Language",
                id: i.id,
              }),
            ),
            { type: "Languages" },
          ]
        : [],
  }),
  getLanguageById: builder.query<LanguageResponse, number>({
    query: (id) => `/languages/${id}/`,
    providesTags: (result): TagType[] =>
      result
        ? [
            {
              type: "Language",
              id: result.id,
            },
            { type: "Languages" },
          ]
        : [],
  }),
  getCountries: builder.query<
    PaginatedResponse<CountryResponse> | CountryResponse[],
    CountryQueryParams
  >({
    query: (queryParams) => ({
      url: createUrl("/countries/", queryParams),
      method: "GET",
    }),
    providesTags: (result): TagType[] =>
      result
        ? [
            ...(
              (isPaginatedResponse(result)
                ? result.results
                : result) as CountryResponse[]
            ).map(
              (i): TagType => ({
                type: "Country",
                id: i.id,
              }),
            ),
            { type: "Countries" },
          ]
        : [],
  }),
  getCountryById: builder.query<CountryResponse, number>({
    query: (id) => `/countries/${id}/`,
    providesTags: (result): TagType[] =>
      result
        ? [
            {
              type: "Country",
              id: result.id,
            },
            { type: "Countries" },
          ]
        : [],
  }),
  getAchievements: builder.query<
    AchievementResponse[] | PaginatedResponse<AchievementResponse>,
    AchievementQueryParams
  >({
    query: (filters) => createUrl("/achievements/", filters),
  }),
  getCommunityRoles: builder.query<
    CommunityRoleResponse[] | PaginatedResponse<CommunityRoleResponse>,
    CommunityRoleQueryParams
  >({
    query: (filters) => createUrl("/community-roles/", filters),
  }),
});

export default commonService;
